import React, {useState,useEffect,useContext} from "react";
import { useNavigate  } from 'react-router-dom';
import Lang from '../lang/translations';
import helpersFunction from '../_helpers/helpersFunction';
import Context from '../context/context';
import CryptoJS from "react-native-crypto-js";

export default function LanderAutologin(props) {

    const folder = helpersFunction.getCDNfolder()
    const [user, setUser] = useState();
    const country = helpersFunction.getCountry()
    const  context = useContext(Context)
    
    useEffect(() => {
        
        var element = null
        element = document.createElement('img')
        element.src = "https://uniallel-conary.icu/postback?cid="+props.clickid+"&et=clickOnMail"
        element.width = "0"
        element.height = "0"
        document.body.appendChild(element)
        
     
        if(!props.reload){
            if(props.notifica == undefined){
                helpersFunction.logToBackend("Redirect NO notifica",props)
                window.location.replace(props.red)
                return
            }else{
                var token = localStorage.getItem('token')
                try{
                    fetch(process.env.REACT_APP_APIADDRESS+"/users/"+props.clickid, {
                        method: 'get',
                        headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer '+ token,
                        'RemarketingClickid': props.remarketingClickid
                        }
                    })
                    .then(response => response.json())
                    .then(res => {
                        let bytes  = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_CHIAVE_CRIPTAZIONE)
                        let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
                       
                        setUser(user)
                        
                    })
                    .catch((err)=>{
                        console.log("Errore chiamata landing autologin",err)
                        window.location.replace(props.red)
                    })
                }catch(err){
                    helpersFunction.logToBackend("Errore su recupero utente lander autologin",{err:err})
                }
            }
            
           
        } 

        
	},[]); 

    return (
        <div>
        {user &&(<div className="all-container bg-light lander_autologin">
			<div className="container filters-no-padding" role="main">
                <div className="angelImageContainer">
                    <img className="busta" src="/img/love-message.svg"/>
                    <img className="angelImage" src={process.env.REACT_APP_CDN+"/"+folder+"/"+props.notifica.angelId+".jpg"}/>
                </div>
				<h1><Lang w={"titolone"} page={"landingAutologin"}/></h1>
                <p><Lang w={"testo"} page={"landingAutologin"} placeholders={{angel:props.notifica.screenName,regione:user.region}}/></p>
                <button onClick={()=>window.location.replace(props.red)}><Lang w={"pulsante"} page={"landingAutologin"}/></button>
			</div>
		</div>)}
        
        </div>
        
 )

}